import { Button, Col, Typography } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { IEventInscriptionSingle } from "../../../../redux/@types";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { eventsInscriptionsService } from "../../../../shared/services";
import { useEventsInscriptions, useTableEventsInscriptions } from "../../hooks";
import Table from "../../../../shared/components/ui/Table";
import { decimal } from "../../../../shared/utils/Helper";

const { Title } = Typography;

export const TableEventsInscriptions = () => {
  const { setTableProps, updateStatus, isLoading, idForInscription } =
    useEventsInscriptions();
  const { changeEventInscriptionForUpdate, showDeleteConfirm } =
    useTableEventsInscriptions();

  const columns: TableColumns<IEventInscriptionSingle> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Título",
      width: 8,
      dataIndex: "title",
      key: "title",
      filterType: "text",
    },
    {
      title: "Precio",
      width: 7,
      dataIndex: "price",
      key: "price",
    },
    {
      title: "URL externa",
      width: 8,
      dataIndex: "external_url",
      key: "external_url",
    },
    {
      title: "Prioridad",
      width: 3,
      dataIndex: "priority",
      key: "priority",
    },
    {
      title: "Estado",
      width: 4,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                if (item.status === "active") {
                  updateStatus("inactive", item.id);
                } else if (item.status === "inactive") {
                  updateStatus("active", item.id);
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 3,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeEventInscriptionForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.title}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];
  return (
    <Table<IEventInscriptionSingle>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
        event_id: idForInscription,
      }}
      service={eventsInscriptionsService}
      onLoad={setTableProps}
    />
  );
};
